import ResourceManager from "@/components/admin/ResourceManager";
import { Field, Toggle } from "@/components/admin/Primitives";

export default function Stats() {
  return (
    <ResourceManager
      resource="stats"
      title="Stats Counter"
      subtitle="The big numbers shown on the homepage. Symbols and formatting are up to you (e.g. 90+, 2,548, ★4.9, LKR 1M+)."
      defaults={{ label: "Players", value: "0", order: 0, is_active: true }}
      columns={[
        { key: "label", label: "Label" },
        { key: "value", label: "Value" },
        { key: "order", label: "Order" },
        { key: "is_active", label: "Active" },
      ]}
      renderForm={(form, setForm) => (
        <>
          <Field label="Label (e.g. Players, Matches, Years)" value={form.label} onChange={(v) => setForm({ ...form, label: v })} required testid="stat-label" />
          <Field label="Value (add any symbol, e.g. 90+ or ★4.9 or LKR 1M+)" value={form.value} onChange={(v) => setForm({ ...form, value: v })} required testid="stat-value" />
          <Field label="Display order" type="number" value={form.order} onChange={(v) => setForm({ ...form, order: v })} testid="stat-order" />
          <Toggle label="Active" checked={form.is_active} onChange={(v) => setForm({ ...form, is_active: v })} testid="stat-active" />
        </>
      )}
    />
  );
}
